// Разбор APK прямо в браузере: ZIP central directory + бинарный AndroidManifest.xml.
// Порт apk_package_name() / apk_icon() из Python-версии.

async function inflateRaw(bytes) {
  const ds = new DecompressionStream("deflate-raw");
  const stream = new Blob([bytes]).stream().pipeThrough(ds);
  return new Uint8Array(await new Response(stream).arrayBuffer());
}

/** Читает оглавление ZIP (только central directory), не загружая весь файл в память. */
export async function zipEntries(file) {
  const tailSize = Math.min(file.size, 65557);
  const tail = new DataView(await file.slice(file.size - tailSize).arrayBuffer());
  let eocd = -1;
  for (let i = tail.byteLength - 22; i >= 0; i--) {
    if (tail.getUint32(i, true) === 0x06054b50) { eocd = i; break; }
  }
  if (eocd < 0) throw new Error("Это не ZIP/APK");
  const count = tail.getUint16(eocd + 10, true);
  const cdSize = tail.getUint32(eocd + 12, true);
  const cdOffset = tail.getUint32(eocd + 16, true);
  const cd = new DataView(await file.slice(cdOffset, cdOffset + cdSize).arrayBuffer());
  const dec = new TextDecoder();
  const entries = [];
  let p = 0;
  for (let i = 0; i < count && p + 46 <= cd.byteLength; i++) {
    if (cd.getUint32(p, true) !== 0x02014b50) break;
    const method = cd.getUint16(p + 10, true);
    const compSize = cd.getUint32(p + 20, true);
    const size = cd.getUint32(p + 24, true);
    const nameLen = cd.getUint16(p + 28, true);
    const extraLen = cd.getUint16(p + 30, true);
    const commentLen = cd.getUint16(p + 32, true);
    const offset = cd.getUint32(p + 42, true);
    const name = dec.decode(new Uint8Array(cd.buffer, p + 46, nameLen));
    entries.push({ name, method, compSize, size, offset });
    p += 46 + nameLen + extraLen + commentLen;
  }
  return entries;
}

export async function zipRead(file, entry) {
  const head = new DataView(await file.slice(entry.offset, entry.offset + 30).arrayBuffer());
  const start = entry.offset + 30 + head.getUint16(26, true) + head.getUint16(28, true);
  const raw = new Uint8Array(await file.slice(start, start + entry.compSize).arrayBuffer());
  if (entry.method === 0) return raw;
  if (entry.method === 8) return inflateRaw(raw);
  throw new Error("Неподдерживаемое сжатие ZIP: " + entry.method);
}

/** package из бинарного AndroidManifest.xml */
export function axmlPackage(data) {
  const dv = new DataView(data.buffer, data.byteOffset, data.byteLength);
  const strings = [];
  let pos = 8;
  while (pos + 8 <= dv.byteLength) {
    const type = dv.getUint16(pos, true);
    const headerSize = dv.getUint16(pos + 2, true);
    const size = dv.getUint32(pos + 4, true);
    if (!size) break;
    if (type === 0x0001) {
      const count = dv.getUint32(pos + 8, true);
      const flags = dv.getUint32(pos + 16, true);
      const stringsStart = dv.getUint32(pos + 20, true);
      const utf8 = (flags & 0x100) !== 0;
      const base = pos + stringsStart;
      for (let i = 0; i < count; i++) {
        let p = base + dv.getUint32(pos + headerSize + i * 4, true);
        if (utf8) {
          p += data[p] & 0x80 ? 2 : 1;
          let n = data[p];
          if (n & 0x80) { n = ((n & 0x7f) << 8) | data[p + 1]; p++; }
          p++;
          strings.push(new TextDecoder().decode(data.subarray(p, p + n)));
        } else {
          let n = dv.getUint16(p, true); p += 2;
          if (n & 0x8000) { n = ((n & 0x7fff) << 16) | dv.getUint16(p, true); p += 2; }
          strings.push(new TextDecoder("utf-16le").decode(data.subarray(p, p + n * 2)));
        }
      }
    } else if (type === 0x0102) {
      if (strings[dv.getUint32(pos + 20, true)] === "manifest") {
        const attrStart = dv.getUint16(pos + 24, true);
        const attrSize = dv.getUint16(pos + 26, true);
        const attrCount = dv.getUint16(pos + 28, true);
        for (let i = 0; i < attrCount; i++) {
          const a = pos + 16 + attrStart + i * attrSize;
          if (strings[dv.getUint32(a + 4, true)] === "package") {
            const raw = dv.getUint32(a + 8, true);
            return raw === 0xffffffff ? null : strings[raw];
          }
        }
        return null;
      }
    }
    pos += size;
  }
  return null;
}

/** { package, iconBlob } — всё, что можно достать без aapt. */
export async function apkInfo(file) {
  const info = { package: null, icon: null };
  try {
    const entries = await zipEntries(file);
    const manifest = entries.find((e) => e.name === "AndroidManifest.xml");
    if (manifest) info.package = axmlPackage(await zipRead(file, manifest));
    const pngs = entries.filter((e) => e.name.startsWith("res/") && /\.(png|webp)$/i.test(e.name));
    const pick =
      pngs.filter((e) => /ic_launcher(?!_background|_foreground)/.test(e.name) && !e.name.includes("round")) ;
    const list = pick.length ? pick : pngs.filter((e) => e.name.includes("ic_launcher")).length
      ? pngs.filter((e) => e.name.includes("ic_launcher")) : pngs.filter((e) => e.name.includes("mipmap"));
    if (list.length) {
      const best = list.reduce((a, b) => (b.size > a.size ? b : a));
      const bytes = await zipRead(file, best);
      info.icon = new Blob([bytes], { type: best.name.endsWith(".webp") ? "image/webp" : "image/png" });
    }
  } catch (e) {
    console.warn("apkInfo", e);
  }
  return info;
}
